var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-search-query-date-range-value" } },
    [
      _c("base-search-query-labels", {
        attrs: { param: _vm.param, schema: _vm.schema },
      }),
      _vm._v(" "),
      _vm.param.value && _vm.param.value.from
        ? _c(
            "span",
            {
              attrs: {
                "data-label": "search-param-value",
                title: _vm.dateFromLabel,
              },
            },
            [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.dateFromLabel)),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.param.value && _vm.param.value.to
        ? _c(
            "span",
            {
              attrs: {
                "data-label": "search-param-value",
                title: _vm.dateToLabel,
              },
            },
            [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.dateToLabel)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: { "data-button": "delete-param" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete-param", _vm.param)
                    },
                  },
                },
                [_c("or-icon", { attrs: { icon: "close" } })],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }